// extracted by mini-css-extract-plugin
export default {"control":"Product_control__0P10f","richText":"Product_richText__UQugg"};